export default __webpack_public_path__ + "static/media/AnimalsYellow_05.e85a29ac.png";